// Copyright (c) 2017 Deere & Company

import React, {PropTypes} from 'react';
import StatusChange, {getDefaultState as getStatusChangeDefaultState} from '@deere/cps-it.warranty-model-factory/lib/status-change';
import {
    filterCollection,
    sortCollection
} from '../../../../shared/services/collections';
import Accordion from '../../../../shared/components/accordion';
import {FormattedMessage} from 'react-intl';
import MachineStatusFilterOptions from '../../services/machine-status-filter-options';
import MachineStatusSortOptions from '../../services/machine-status-sort-options';
import MachineStatusUpdateModal from './machine-status-update-modal';
import MachineStatusUpdatesListItem from './machine-status-updates-list-item';
import RefinableListWidgetWithExport from '../../../../shared/components/refinable-list-widget/refinable-list-widget-with-export';
import SearchFilters from '../../../../shared/state/search-filters';
import TcsmApproveDenyModal from '../../state/tcsm-approve-deny-modal';
import {buildNumber} from '../../../../shared/services/build-number';

function handleExportToExcel() {

    this.actions.exportMachineStatusUpdates();

}

function handleFilterByChange(filterBy) {

    this.actions.updateMachineStatusListFilterBy(filterBy);

}

function handleSortByChange(sortBy) {

    this.actions.updateMachineStatusListSortBy(sortBy);

}

function handleSortDirectionChange(sortDirection) {

    this.actions.updateMachineStatusListSortDirection(sortDirection);

}

function handleOpenUpdateStatusChangeModal(item, actionToTake) {

    this.actions.machineStatusItemToUpdate(item);
    this.actions.openMachineStatusModal(actionToTake);

}

function handleCloseUpdateStatusChangeModal() {

    this.actions.closeMachineStatusModal();
    this.actions.machineStatusItemToUpdate(getStatusChangeDefaultState());

}

function handleCommentsToDealerChange(comments) {

    this.actions.updateCommentsToDealer(comments);

}

function handleMachineStatusModalConfirmation(actionToTake, itemToUpdate) {

    this.actions.approveDenyMachineStatus(actionToTake, itemToUpdate);

}

function handleInternalDeereCommentsChange(comments) {

    this.actions.updateInternalDeereComments(comments);

}

const MachineStatusUpdatesAccordion = props => {

    let sortedCollection;

    sortedCollection = [...props.machineStatusUpdates];
    sortedCollection = sortCollection(props.machineStatusSearchFilters.sortBy, props.machineStatusSearchFilters.sortDirection, sortedCollection);
    sortedCollection = filterCollection(props.machineStatusSearchFilters.filterBy, MachineStatusFilterOptions, sortedCollection);

    const body = (
        <div>
            <RefinableListWidgetWithExport
                hasResults={props.machineStatusUpdates.length > 0}
                onExport={handleExportToExcel.bind(props)}
                onFilterByChange={props::handleFilterByChange}
                onSortByChange={props::handleSortByChange}
                onSortDirectionChange={props::handleSortDirectionChange}
                searchFilters={props.machineStatusSearchFilters}
                sortOptions={MachineStatusSortOptions}
            />
            {sortedCollection.map(item =>
                <MachineStatusUpdatesListItem
                    item={item}
                    key={item.id}
                    openUpdateStatusChangeModal={props::handleOpenUpdateStatusChangeModal}
                />
            )}
        </div>);

    const title = (
        <div className='machine-status-updates-title'>
            <FormattedMessage
                id='MACHINE_STATUS_UPDATES_WITH_COUNT'
                values={{
                    count: buildNumber(sortedCollection.length)
                }}
            />
        </div>
    );

    return props.machineStatusUpdates.length > 0 &&
        <div>
            <Accordion
                accordionId='machine-status-updates'
                body={body}
                secondaryHeaderNode={null}
                title={title}
            />
            <MachineStatusUpdateModal
                closeUpdateStatusChangeModal={props::handleCloseUpdateStatusChangeModal}
                machineStatusItemToUpdate={props.machineStatusItemToUpdate}
                machineStatusModal={props.machineStatusModal}
                onCommentsToDealerChange={props::handleCommentsToDealerChange}
                onConfirmation={props::handleMachineStatusModalConfirmation}
                onInternalDeereCommentsChange={props::handleInternalDeereCommentsChange}
            />
        </div>;

};

MachineStatusUpdatesAccordion.displayName = 'MachineStatusUpdatesAccordion';
MachineStatusUpdatesAccordion.propTypes = {
    actions: PropTypes.object.isRequired,
    machineStatusItemToUpdate: PropTypes.instanceOf(StatusChange).isRequired,
    machineStatusModal: PropTypes.instanceOf(TcsmApproveDenyModal).isRequired,
    machineStatusSearchFilters: PropTypes.instanceOf(SearchFilters).isRequired,
    machineStatusUpdates: PropTypes.arrayOf(PropTypes.instanceOf(StatusChange)).isRequired
};

export default MachineStatusUpdatesAccordion;



// WEBPACK FOOTER //
// ./src/tcsm/wip/components/machine-status-updates/machine-status-updates-accordion.js